function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.11 10.06L-.01 9l3.86-3.95-3.87-3.99L1.11 0 6.1 5.06z",
  fill: "#333",
  fillRule: "evenodd"
});

var SvgIconArrowRightBlack = function SvgIconArrowRightBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6.12,
    height: 10.06
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjEyIiBoZWlnaHQ9IjEwLjA2IiB2aWV3Qm94PSIwIDAgNi4xMiAxMC4wNiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogIzMzMzsKICAgICAgICBmaWxsLXJ1bGU6IGV2ZW5vZGQ7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxwYXRoIGlkPSJhcnJvdy5zdmciIGNsYXNzPSJjbHMtMSIgZD0iTTMxNzYuOTksMjMwNC4wM2wtMS4xMi0xLjA2LDMuODYtMy45NS0zLjg3LTMuOTksMS4xMy0xLjA2LDQuOTksNS4wNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMTc1Ljg4IC0yMjkzLjk3KSIvPgo8L3N2Zz4K";
export { SvgIconArrowRightBlack as ReactComponent };